import React from 'react';

import { useTranslation } from 'react-i18next';

import { RhythmScoreBadge } from '@pkg/components';

import { type EmojiCopy } from '@app/client';

import './RhythmScoreModal.scss';

interface RhythmScoreModalProps {
    generation?: number;
    rhythmScore: number;
    rhythmScoreCopy: EmojiCopy;
}

export const RhythmScoreModal = ({ generation, rhythmScore, rhythmScoreCopy }: RhythmScoreModalProps) => {
    const { t } = useTranslation(['common', 'payment']);

    return (
        <article className="yat-picker-rs-modal">
            <header className="yat-picker-rs-modal__header">
                <RhythmScoreBadge
                    generation={generation}
                    score={rhythmScore}
                    classes="yat-picker-rs-modal__rhythm-score-badge v2-text-heading-1"
                />
                <h2 id="yat-picker-rs-modal-title" className="yat-picker-rs-modal__title">
                    {t('rhythm_score')}
                </h2>
            </header>
            <section
                className="yat-picker-rs-modal__description"
                dangerouslySetInnerHTML={{ __html: rhythmScoreCopy.description }}
            />
            {rhythmScoreCopy.features.length > 0 && (
                <section>
                    <h3 className="yat-picker-rs-modal__features-title">{t('payment:a_bit_why_yat_special')}</h3>
                    <ul className="yat-picker-rs-modal__features-list">
                        {rhythmScoreCopy.features.map(function (item, i) {
                            return (
                                <li key={i} className="yat-picker-rs-modal__features-list-item">
                                    <span dangerouslySetInnerHTML={{ __html: item }} />
                                </li>
                            );
                        })}
                    </ul>
                </section>
            )}
        </article>
    );
};
